module.exports = __webpack_public_path__ + "images/category_lp/watch/rolex_samples/pattern_c2/sec05_sp_54daf1bcfb172704c7cbe0ec7db70a73.png";